var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.giveawaySucShow
    ? _c("div", { staticClass: "popup", attrs: { id: "giveawaySucPopup" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contentShow,
                expression: "contentShow"
              }
            ],
            staticClass: "giveaway-content",
            style: "transform: scale(" + _vm.screenWidthRatio + ");",
            attrs: { id: "giveawaySuc" }
          },
          [
            _c(
              "div",
              {
                staticClass: "giveaway-close-btn",
                on: {
                  click: function($event) {
                    return _vm.closePage()
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 14 14",
                      fill: "none"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M1 1L13 13M13 1L1 13",
                        stroke: "white",
                        "stroke-width": "1.8",
                        "stroke-linecap": "round"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "giveaway-header" }, [
              _c("div", { staticClass: "giveaway-header-text" }, [
                _c("div", { staticClass: "giveaway-header-title" }, [
                  _c("img", {
                    staticClass: "giveaway-header-icon",
                    attrs: {
                      src: require("../../../assets/images/giveaway/260611/ic-40-keys.svg"),
                      alt: "keys"
                    }
                  }),
                  _vm._v(
                    "\n                  " +
                      _vm._s(
                        _vm.$t(
                          "language.popup.giveawayActiveSucPopup.headerTitle"
                        )
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "giveaway-header-subtitle" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.popup.giveawayActiveSucPopup.headerSubtitle"
                      )
                    )
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "giveaway-body" }, [
              _c("div", { staticClass: "giveaway-compare" }, [
                _c("div", { staticClass: "compare-card compare-card-left" }, [
                  _c("div", { staticClass: "compare-card-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.popup.giveawayActiveSucPopup.currentPlanName"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "compare-card-status" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/images/giveaway/260611/ic-16-activated.svg"),
                        alt: "activated"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.giveawayActiveSucPopup.currentPlanBadge"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "compare-features" }, [
                    _c("li", { staticClass: "compare-feature-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/giveaway/260611/ic-gou-blue.svg"),
                          alt: "check"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.feature1"
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "compare-feature-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/giveaway/260611/ic-gou-blue.svg"),
                          alt: "check"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.feature2",
                              { traffic: _vm.giveawayTraffic }
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "compare-feature-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/giveaway/260611/ic-gou-blue.svg"),
                          alt: "check"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.feature3"
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "compare-arrow" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/giveaway/260611/img-jiantou.png"),
                      alt: "arrow"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "compare-card compare-card-right" }, [
                  _c("div", { staticClass: "compare-card-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.popup.giveawayActiveSucPopup.upgradePlanName"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "compare-card-price-all-row" }, [
                    _c("div", { staticClass: "compare-card-price-row" }, [
                      _c("span", { staticClass: "price-symbol" }, [
                        _vm._v("$")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "price-current" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.upgradePlanCurrentPrice"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "price-original" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.upgradePlanOriginalPrice"
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/images/giveaway/260611/80-off.png"),
                        alt: "check"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "compare-features" }, [
                    _c("li", { staticClass: "compare-feature-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/giveaway/260611/ic-gou-red.svg"),
                          alt: "check"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.featureUpgrade1"
                            )
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "compare-feature-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/giveaway/260611/ic-gou-red.svg"),
                          alt: "check"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.featureUpgrade2"
                            )
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "compare-feature-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/giveaway/260611/ic-gou-red.svg"),
                          alt: "check"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.featureUpgrade3"
                            )
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "compare-feature-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/giveaway/260611/ic-gou-red.svg"),
                          alt: "check"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "language.popup.giveawayActiveSucPopup.featureUpgrade4"
                            )
                          )
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "giveaway-upgrade-btn" }, [
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handleUpgrade()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.popup.giveawayActiveSucPopup.btnUpgrade"
                        )
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.countdownSeconds > 0
                ? _c("div", { staticClass: "giveaway-countdown" }, [
                    _c("span", { staticClass: "countdown-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.giveawayActiveSucPopup.countdownLabel"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "countdown-highlight" }, [
                      _vm._v(
                        _vm._s(_vm.countdownMinutes) +
                          " min : " +
                          _vm._s(_vm.countdownSecondsDisplay) +
                          " sec"
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ff928fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff928fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/upgrade_popups/giveaway_active_suc_popup.vue
// module id = null
// module chunks = 